import { FC } from 'react';
import { Modal, Button, Icon } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../../../../Localization';

interface CallConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  contactName: string;
  phoneNumber: string;
}

/**
 * Modal to confirm starting a phone call with a contact
 */
export const CallConfirmationModal: FC<CallConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  contactName,
  phoneNumber
}) => {
  const L = useLocalizedStrings();

  const message = L.applicant.comms.confirm_start_call_message
    .replace('$name', contactName)
    .replace('$number', phoneNumber);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={L.applicant.comms.confirm_start_call}
      size="sm"
    >
      <div className="mt-2">
        <p className="text-sm text-gray-500">
          {message}
        </p>
      </div>
      <div className="mt-3 flex gap-3 justify-end">
        <Button variant="secondary" onClick={onClose}>
          {L.applicant.comms.consent.cancel}
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          icon={<Icon type="solid" name="PhoneIcon" />}
        >
          {L.applicant.comms.start_call_button}
        </Button>
      </div>
    </Modal>
  );
};
